"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspirationIndexSettingsConfig = void 0;
const defaultAlgoliaIndex_config_1 = require("../defaultAlgoliaIndex.config");
const schemaName_1 = require("../schemaName");
exports.inspirationIndexSettingsConfig = {
    schemaName: schemaName_1.SchemaName.inspiration,
    settings: (language) => (Object.assign(Object.assign(Object.assign(Object.assign({}, defaultAlgoliaIndex_config_1.defaultAlgoliaIndexConfig), defaultAlgoliaIndex_config_1.defaultPageFieldConfig), (0, defaultAlgoliaIndex_config_1.defaultIndexLanguageConfig)(language)), { searchableAttributes: [
            'unordered(category)',
            'unordered(name)',
            'unordered(description)',
            'unordered(keywords)',
            'unordered(occasions)',
            'unordered(author)',
            'contents.page'
        ], ranking: [
            'desc(publishDate)',
            ...defaultAlgoliaIndex_config_1.defaultPageFieldConfig.ranking
        ] }))
};
